import React, { useState } from "react";
import { ReactComponent as ArrowL } from "../../assets/img/arrow-left.svg";
import AuthService from "services/auth.service";
import defaultImage from "../../assets/img/default-avatar.png";
import { ReactComponent as ArrowR } from "../../assets/img/arrow-right.svg";
import { NavLink } from "react-router-dom";
import {API_URL_IMAGE} from "../../services/config";
import { Form, Input } from "reactstrap";

const Modal = ({ content, setIsModalOpen }) => {
  const [isNestedModalOpen, setIsNestedModalOpen] = useState(false);
  const [nestedContent, setNestedContent] = useState("");

  const handleNestedOptionClick = (content) => {
    setNestedContent(content);
    setIsNestedModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(AuthService.getCurrentUser());

  //logic for profile image

  

  const imageDir = currentUser.imageURL;
  let profileImage = `${API_URL_IMAGE}${imageDir}`;

  // Check if imageURL ends with 'none', if yes, use the default image
  if (profileImage.endsWith("none")) {
    profileImage = defaultImage;
  }

  const logOut = () => {
    AuthService.logout();
    setShowAdminBoard(false);
    setCurrentUser(null);
  };

  return (
    <div className="jag-modal-overlay">
      <div className="jag-modal-content">
        <button onClick={handleClose} className="jag-close-button">
          <ArrowL />
          {content}
        </button>

        {content === "My Account" && (
          <>
            <div className="immmaagg">
              <img
                src={profileImage}
                alt="User Avatar"
                className="jag-avatar"
              />
            </div>
            <div className="inputs-1">
              <label> Name</label>
              <div className="input-feild-1">
                <i class="input-icon fa-regular fa-user"></i>
                <Input
                  type="text"
                  className="input-control"
                  name="Name"
                  placeholder="Name"
                  defaultValue={`${currentUser.firstName} ${currentUser.lastName}`}
                  disabled
                />
              </div>
              <label>Email</label>
              <div className="input-feild-1">
                <i className="input-icon fa-regular fa-envelope"></i>
                <Input
                  type="text"
                  className="input-control"
                  name="email"
                  placeholder="Email"
                  defaultValue={currentUser.email}
                  disabled
                />
              </div>
              <label>Phone</label>
              <div className="input-feild-1">
                <i class="input-icon fa-solid fa-phone"></i>
                <Input
                  type="text"
                  className="input-control"
                  name="mobileNumber"
                  placeholder="Mobile Number"
                  value={currentUser.mobileNumber}
                  disabled
                />
              </div>
            </div>

            <div className="button-div-1">
              <button className="loginbutton-1 sizzee" disabled>
                <span>Save</span>
              </button>
            </div>
          </>

          //   <div className="jag-my-account">
          //     <img src="user-avatar.jpg" alt="User Avatar" className="jag-avatar" />
          //     <input type="text" placeholder="Name" defaultValue="John Doe" />
          //     <input type="email" placeholder="Email" defaultValue="doe@gmail.com" />
          //     <input type="text" placeholder="Phone" />
          //     <button>Save</button>
          //   </div>
        )}

        {content === "Settings" && (
          <>
            <div className="inputs-1">
              <label> General</label>
              <div onClick={() => handleNestedOptionClick("Reset Password")}>
                Reset Password <ArrowR className="jag-arwR" />
              </div>
              <br />
              <div>Notifications</div>
              <br />
              <br />
              <label>Security</label>
              <div> Privacy Policy </div>
              <label>Choose what you want to share with us</label>

              <div className="button-div-1">
                <NavLink
                  to="/"
                  onClick={logOut}
                  className="loginbutton-1 sizzee"
                >
                  Log Out
                </NavLink>
              </div>
            </div>
          </>
        )}
        {content === "Help Center" && (
          <>
            <div className="inputs-1">
              <div class="jaja-help-center">
                
                <p>If you have any questions, feel free to reach out to us:</p>
                <div class="jaja-contact-item">
                  <i class="fas fa-envelope"></i>
                  <a href="mailto:Allusmassagecouncil@gmail.com">Allusmassagecouncil@gmail.com</a>
                </div>
                <div class="jaja-contact-item">
                  <i class="fas fa-envelope"></i>
                  <a href="mailto:Americanmassagecouncil@gmail.com">Americanmassagecouncil@gmail.com</a>
                </div>
                <div class="jaja-contact-item">
                  <i class="fas fa-phone"></i>
                  <a href="tel:+14047291859">+1 (404) 729-1859</a>
                </div>
              </div>
            </div>
          </>
        )}
        {content === "Contact" && (
          <>
            <div className="inputs-1">
              <div class="jaja-help-center">
                
                <p>If you have any questions, feel free to reach out to us:</p>
                <div class="jaja-contact-item">
                  <i class="fas fa-envelope"></i>
                  <a href="mailto:Allusmassagecouncil@gmail.com">Allusmassagecouncil@gmail.com</a>
                </div>
                <div class="jaja-contact-item">
                  <i class="fas fa-envelope"></i>
                  <a href="mailto:Americanmassagecouncil@gmail.com">Americanmassagecouncil@gmail.com</a>
                </div>
                <div class="jaja-contact-item">
                  <i class="fas fa-phone"></i>
                  <a href="tel:14047291859">+1 (404) 729-1859</a>
                </div>
              </div>
            </div>
          </>
        )}
        {isNestedModalOpen && (
          <div className="jag-modal-overlay">
            <div className="jag-modal-content">
              <button
                onClick={() => setIsNestedModalOpen(false)}
                className="jag-close-button"
              >
                <ArrowL />
                General
              </button>

              {nestedContent === "Reset Password" && (
                <>
                  <div className="inputs-1">
                    <label> Old Password</label>
                    <div className="input-feild-1">
                      <i class="input-icon fa-solid fa-lock"></i>
                      <Input
                        type="text"
                        className="input-control"
                        name="oldPassword"
                        placeholder="Enter Old Password"
                        disabled
                      />
                    </div>
                    <label>New Password</label>
                    <div className="input-feild-1">
                      <i className="input-icon fa-solid fa-lock"></i>
                      <Input
                        type="text"
                        className="input-control"
                        name="EnterPassword"
                        placeholder="Enter Password"
                        disabled
                      />
                    </div>
                    <label>Retype New Password</label>
                    <div className="input-feild-1">
                      <i class="input-icon fa-solid fa-lock"></i>
                      <Input
                        type="text"
                        className="input-control"
                        name="RetypePassword"
                        placeholder="Retype Password"
                        disabled
                      />
                    </div>
                  </div>

                  <div className="button-div-1">
                    <button className="loginbutton-1 sizzee" disabled>
                      <span>Save</span>
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
